// extracted by mini-css-extract-plugin
export default {"categories":"CategorySection_categories__8Carq"};